globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { useState, useMemo, useCallback } from 'react';
import Image from 'next/image';
import { Menu } from '@headlessui/react';
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/react';
import 'react-phone-number-input/style.css';
import { getCountries } from 'react-phone-number-input/input'; //@ts-expect-error - no types available

import countryNames from 'react-phone-number-input/locale/it';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CountriesMenu(_ref) {
  var onSelect = _ref.onSelect,
      favorites = _ref.favorites,
      defaultCountry = _ref.defaultCountry,
      wrapperStyle = _ref.wrapperStyle;

  var _useState = useState(defaultCountry),
      selectedCountry = _useState[0],
      setSelectedCountry = _useState[1];

  var _useFloating = useFloating({
    placement: 'bottom-start',
    middleware: [offset(8), flip(), shift()],
    whileElementsMounted: autoUpdate
  }),
      refs = _useFloating.refs,
      floatingStyles = _useFloating.floatingStyles;

  var handleSelection = useCallback(function (newValue) {
    setSelectedCountry(newValue);
    onSelect && onSelect(newValue);
  }, [onSelect]);
  var countries = useMemo(function () {
    return filterCountries(getCountries(), favorites);
  }, [favorites]);
  return /*#__PURE__*/_jsx(Wrapper, {
    twStyle: wrapperStyle,
    children: /*#__PURE__*/_jsxs(Menu, {
      children: [/*#__PURE__*/_jsxs(_StyledMenuButton, {
        ref: refs.setReference,
        children: [/*#__PURE__*/_jsx("span", {
          children: renderFlag(selectedCountry)
        }), /*#__PURE__*/_jsx("span", {
          children: selectedCountry
        })]
      }), /*#__PURE__*/_jsx(_StyledMenuItems, {
        ref: refs.setFloating,
        style: floatingStyles,
        children: countries === null || countries === void 0 ? void 0 : countries.map(function (country) {
          return /*#__PURE__*/_jsx(Menu.Item, {
            children: function children(_ref2) {
              var active = _ref2.active;
              return /*#__PURE__*/_jsxs(StyledButton, {
                isActive: active,
                isLastFavorite: !!(favorites !== null && favorites !== void 0 && favorites.includes(country)) && favorites[favorites.length - 1] === country,
                onClick: function onClick() {
                  return handleSelection(country);
                },
                children: [/*#__PURE__*/_jsx("span", {
                  children: renderFlag(country)
                }), /*#__PURE__*/_jsx("span", {
                  children: countryNames[country]
                })]
              });
            }
          }, country);
        })
      })]
    })
  });
}
export default CountriesMenu;

var renderFlag = function renderFlag(country) {
  return /*#__PURE__*/_jsx(Image, {
    src: "https://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(country, ".svg"),
    alt: "flag icon",
    height: 11,
    width: 16
  });
};

var filterCountries = function filterCountries(countries, favorites) {
  if (!favorites || favorites.length === 0) return countries;
  countries = countries.filter(function (country) {
    return !favorites.includes(country);
  });

  for (var i = favorites.length - 1; i >= 0; i--) {
    countries.unshift(favorites[i]);
  }

  return countries;
};

var Wrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "countries-menu__Wrapper",
  componentId: "sc-1pkuo3l-0"
})(["", ""], function (_ref3) {
  var twStyle = _ref3.twStyle;
  return twStyle || {};
});

var StyledButton = /*#__PURE__*/_styled.button.withConfig({
  displayName: "countries-menu__StyledButton",
  componentId: "sc-1pkuo3l-1"
})(["", " ", " ", ""], {
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "columnGap": "0.25rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "textAlign": "left",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem"
}, function (_ref4) {
  var isActive = _ref4.isActive;
  return isActive ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(243 244 246 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  };
}, function (_ref5) {
  var isLastFavorite = _ref5.isLastFavorite;
  return isLastFavorite ? {
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))"
  } : {};
});

var _StyledMenuButton = /*#__PURE__*/_styled(Menu.Button).withConfig({
  displayName: "countries-menu___StyledMenuButton",
  componentId: "sc-1pkuo3l-2"
})({
  "display": "inline-flex",
  "height": "2rem",
  "width": "49px",
  "alignItems": "center",
  "gap": "0.25rem",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))",
  "padding": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))"
});

var _StyledMenuItems = /*#__PURE__*/_styled(Menu.Items).withConfig({
  displayName: "countries-menu___StyledMenuItems",
  componentId: "sc-1pkuo3l-3"
})({
  "marginTop": "1rem",
  "maxHeight": "120px",
  "width": "320px",
  "maxWidth": "320px",
  "overflowY": "auto",
  "borderRadius": "1rem",
  "borderStyle": "none",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "--tw-shadow": "0px 4px 16px 0px rgba(0, 0, 26, 0.50)",
  "--tw-shadow-colored": "0px 4px 16px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  "@media (min-width: 768px)": {
    "maxHeight": "225px"
  }
});